/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Certificate } from '../models';
/**
 * AdminCertificateApi - axios parameter creator
 * @export
 */
export const AdminCertificateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary All certificates by service request
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCertificatesByServiceRequest: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('allCertificatesByServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/admin/certificate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"Certificate\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCertificate: async (serviceRequestId?: number, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/certificate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (serviceRequestId !== undefined) { 
                localVarFormParams.append('serviceRequestId', serviceRequestId as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"delete\", \"Certificate\"] 
         * @summary Delete a specific certificate uploaded by operator. | Permission required: [\"delete\", \"Certificate\"]
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCertificate: async (fileUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUrl' is not null or undefined
            assertParamExists('deleteCertificate', 'fileUrl', fileUrl)
            const localVarPath = `/admin/certificate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileUrl !== undefined) {
                localVarQueryParameter['fileUrl'] = fileUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCertificateApi - functional programming interface
 * @export
 */
export const AdminCertificateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCertificateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary All certificates by service request
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Certificate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allCertificatesByServiceRequest(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCertificateApi.allCertificatesByServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"Certificate\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCertificate(serviceRequestId?: number, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Certificate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCertificate(serviceRequestId, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCertificateApi.createCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"delete\", \"Certificate\"] 
         * @summary Delete a specific certificate uploaded by operator. | Permission required: [\"delete\", \"Certificate\"]
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCertificate(fileUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCertificate(fileUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCertificateApi.deleteCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCertificateApi - factory interface
 * @export
 */
export const AdminCertificateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCertificateApiFp(configuration)
    return {
        /**
         * 
         * @summary All certificates by service request
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>> {
            return localVarFp.allCertificatesByServiceRequest(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"Certificate\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCertificate(serviceRequestId?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Certificate> {
            return localVarFp.createCertificate(serviceRequestId, files, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"Certificate\"] 
         * @summary Delete a specific certificate uploaded by operator. | Permission required: [\"delete\", \"Certificate\"]
         * @param {string} fileUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCertificate(fileUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCertificate(fileUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCertificateApi - interface
 * @export
 * @interface AdminCertificateApi
 */
export interface AdminCertificateApiInterface {
    /**
     * 
     * @summary All certificates by service request
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApiInterface
     */
    allCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>>;

    /**
     *  **Permission required**: [\"create\", \"Certificate\"] 
     * @summary Create a document to sign
     * @param {number} [serviceRequestId] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApiInterface
     */
    createCertificate(serviceRequestId?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Certificate>;

    /**
     *  **Permission required**: [\"delete\", \"Certificate\"] 
     * @summary Delete a specific certificate uploaded by operator. | Permission required: [\"delete\", \"Certificate\"]
     * @param {string} fileUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApiInterface
     */
    deleteCertificate(fileUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * AdminCertificateApi - object-oriented interface
 * @export
 * @class AdminCertificateApi
 * @extends {BaseAPI}
 */
export class AdminCertificateApi extends BaseAPI implements AdminCertificateApiInterface {
    /**
     * 
     * @summary All certificates by service request
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApi
     */
    public allCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return AdminCertificateApiFp(this.configuration).allCertificatesByServiceRequest(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"Certificate\"] 
     * @summary Create a document to sign
     * @param {number} [serviceRequestId] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApi
     */
    public createCertificate(serviceRequestId?: number, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return AdminCertificateApiFp(this.configuration).createCertificate(serviceRequestId, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"delete\", \"Certificate\"] 
     * @summary Delete a specific certificate uploaded by operator. | Permission required: [\"delete\", \"Certificate\"]
     * @param {string} fileUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCertificateApi
     */
    public deleteCertificate(fileUrl: string, options?: RawAxiosRequestConfig) {
        return AdminCertificateApiFp(this.configuration).deleteCertificate(fileUrl, options).then((request) => request(this.axios, this.basePath));
    }
}

